import React from "react";
import { Navigate } from "react-router-dom";
import { Shield, Lock } from "lucide-react";

const AdminGuard = ({ children, isAdmin }) => {
	if (!isAdmin) {
		return (
			<div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
				<div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
					<div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
						<Lock className="w-8 h-8 text-red-600" />
					</div>
					<h2 className="text-2xl font-bold text-gray-900 mb-2">Access Denied</h2>
					<p className="text-gray-600 mb-6">
						You don't have permission to access the admin dashboard. 
						This area is restricted to authorized administrators only.
					</p>
					<div className="bg-gray-50 rounded-lg p-4 mb-6">
						<p className="text-sm text-gray-500">
							<Shield className="w-4 h-4 inline mr-2" />
							Admin access required
						</p>
					</div>
					<button
						onClick={() => window.history.back()}
						className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors"
					>
						Go Back
					</button>
				</div>
			</div>
		);
	}

	return children;
};

export default AdminGuard;
